import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { Maker } from '@root/entities/trade'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { apiRequest } from '@root/shared/api'

import type { Address } from '@root/entities/address/Address'
import type { PairAddress } from '@root/entities/pair'

export const fetchTxMakerRequestAction = action(
  async (
    ctx,
    {
      network,
      walletAddress,
      pairAddress,
    }: {
      network: Network.Network
      walletAddress: Address
      pairAddress: PairAddress
    },
  ) => {
    const {
      tradeApiClient,
      environment: {
        assets: { avatarsHost },
      },
    } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesMakerGetByAddressCreate, [
        {
          network: Network.toDto(network),
          address: walletAddress,
          pairAddress,
        },
      ]),
    )

    return result.pipe(Result.map((it) => Maker.fromDto(it, avatarsHost)))
  },
  'fetchTxMakerRequestAction',
)
